import React from 'react'

const GuestLayout = ({children}) => {
  return (
    <>
      {children}
    </>
  )
}

export default GuestLayout
